// extracted by mini-css-extract-plugin
export default {"root":"qgvRMK","paper":"DcN8i4","content":"SQ8XPv","editor":"OsaaI4","legacy":"CP0Jfd","next":"fKQCFr"};